<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="ack"> </p>
<p class="FM-Head-fmh"><span epub:type="pagebreak" id="pg_7" title="7"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">Acknowledgments</span></span></span></p>
<p class="FM-Text-No-Indent-fmtx1">I want to thank Lance Polingyouma, Lynn Bullock, and my other coworkers at the Heard Museum for their supreme patience while I hammered this book out on my lunch breaks (and sometimes went over because I lost track of time). Thanks to Elinor Mavor for editing the novella and making it salable, to Neil Clarke for publishing the original novella (even though it was <span class="ePub-I">really</span> long), and to Martha Millard and Jen Gunnels for helping me whip the novel-length manuscript into shape. And thanks to my mom, Margaret Devenport. If I don’t mention her, she’s going to say, “Hey! What about your mom?!”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?758ffedd